/**
 * 是否是数组
 * @public
 */
function isArrayOrArrayClass(target) {
    if (target === Array) {
        return true;
    }
    return Array.isArray(target);
}
/**
 * 是否是集合
 * @public
 */
function isCollection(target) {
    return isArrayOrArrayClass(target)
        || target === Map
        || target instanceof Map
        || target === Set
        || target instanceof Set
        || target === WeakMap
        || target instanceof WeakMap
        || target === WeakSet
        || target instanceof WeakSet;
}
/**
 * 是否是 Promise
 * @public
 */
function isPromise(target) {
    return target === Promise || target instanceof Promise;
}
/**
 * 是否是字符串
 * @public
 */
function isString(target) {
    return typeof target === 'string' || target instanceof String || target === String;
}
/**
 * 是否是数字
 * @public
 */
function isNumber(target) {
    return typeof target === 'number' || target instanceof Number || target === Number;
}
/**
 * 是否是布尔
 * @public
 */
function isBoolean(target) {
    return typeof target === 'boolean' || target instanceof Boolean || target === Boolean;
}
/**
 * 是否是原始类型
 * @public
 */
function isPrimitiveOrPrimitiveClass(target) {
    return isString(target)
        || isNumber(target)
        || isBoolean(target);
}

export { isArrayOrArrayClass, isBoolean, isCollection, isNumber, isPrimitiveOrPrimitiveClass, isPromise, isString };
//# sourceMappingURL=is-utils.js.map
